// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Checkbox, OutlinedInput, ListItemText } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type SelectDropdownProps = {
    label: string;
    allValues: string[];
    values: string[];
    handleSelectChange: (event: SelectChangeEvent<string[]>) => void;
};

export const SelectDropdown = (props: SelectDropdownProps ) => {
    const { label, allValues, values, handleSelectChange } = props;

    return (
        <FormControl sx={{ m: 1, width: 500 }}>
            <InputLabel>{label}</InputLabel>
            <Select
                multiple
                value={values}
                onChange={handleSelectChange}
                input={<OutlinedInput label={label} />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
            >
                {allValues.map((value) => (
                    <MenuItem
                        key={value}
                        value={value}
                    >
                         <Checkbox checked={values.indexOf(value) > -1} />
                        <ListItemText primary={value} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
